/* Consent bar. Stores the choice under "sloos-consent" and hands it to
   Shopify's Customer Privacy API so tracking pixels are actually gated. */
(function () {
  'use strict';

  var KEY = 'sloos-consent';

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY));
    } catch (e) {
      return null;
    }
  }

  function write(value) {
    try {
      localStorage.setItem(KEY, JSON.stringify({ v: 1, at: Date.now(), analytics: value.analytics, marketing: value.marketing }));
    } catch (e) {
      /* Storage can be unavailable; the banner then reappears next visit. */
    }
  }

  function applyToShopify(value) {
    function set() {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: !!value.analytics,
            marketing: !!value.marketing,
            preferences: !!value.analytics,
            sale_of_data: !!value.marketing
          },
          function () {}
        );
      } catch (e) {
        /* Consent API refused the call — the stored choice still stands. */
      }
    }

    if (window.Shopify && window.Shopify.customerPrivacy) {
      set();
    } else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) set();
      });
    }
  }

  if (!customElements.get('consent-notice')) {
    customElements.define(
      'consent-notice',
      class ConsentNotice extends HTMLElement {
        connectedCallback() {
          this.bar = this.querySelector('.consent__bar');
          this.panel = this.querySelector('[data-consent-panel]');
          this.reopen = this.querySelector('[data-consent-act="reopen"]');
          this.choice = { analytics: false, marketing: false };

          var saved = read();
          if (saved) {
            this.choice = { analytics: !!saved.analytics, marketing: !!saved.marketing };
            applyToShopify(this.choice);
            this.collapse();
          } else {
            this.expand();
          }

          this.hidden = false;
          this.addEventListener('click', this.onClick.bind(this));
        }

        expand() {
          this.bar.hidden = false;
          this.reopen.hidden = true;
          this.classList.remove('consent--collapsed');
        }

        collapse() {
          this.bar.hidden = true;
          this.reopen.hidden = false;
          this.classList.add('consent--collapsed');
        }

        decide(value) {
          this.choice = value;
          write(value);
          applyToShopify(value);
          this.collapse();
          this.dispatchEvent(new CustomEvent('consent', { detail: value, bubbles: true }));
        }

        onClick(event) {
          var group = event.target.closest('[data-consent-group]');
          if (group) {
            var name = group.dataset.consentGroup;
            this.choice[name] = !this.choice[name];
            group.setAttribute('aria-checked', this.choice[name] ? 'true' : 'false');
            return;
          }

          var button = event.target.closest('[data-consent-act]');
          if (!button) return;

          switch (button.dataset.consentAct) {
            case 'panel': {
              var open = this.panel.hidden;
              this.panel.hidden = !open;
              button.setAttribute('aria-expanded', open ? 'true' : 'false');
              break;
            }
            case 'reopen':
              this.expand();
              this.panel.hidden = false;
              this.querySelectorAll('[data-consent-group]').forEach(
                function (node) {
                  node.setAttribute('aria-checked', this.choice[node.dataset.consentGroup] ? 'true' : 'false');
                }.bind(this)
              );
              break;
            case 'accept':
              this.decide({ analytics: true, marketing: true });
              break;
            case 'essential':
              this.decide({ analytics: false, marketing: false });
              break;
            case 'save':
              this.decide({ analytics: !!this.choice.analytics, marketing: !!this.choice.marketing });
              break;
          }
        }
      }
    );
  }
})();
